import { render, staticRenderFns } from "./addTaskSectionModal.vue?vue&type=template&id=6373c4c8&scoped=true"
import script from "./addTaskSectionModal.vue?vue&type=script&lang=js"
export * from "./addTaskSectionModal.vue?vue&type=script&lang=js"
import style0 from "./addTaskSectionModal.vue?vue&type=style&index=0&id=6373c4c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6373c4c8",
  null
  
)

export default component.exports